import { render, staticRenderFns } from "./BoxAdmin.vue?vue&type=template&id=547fd6f9"
import script from "./BoxAdmin.vue?vue&type=script&lang=js"
export * from "./BoxAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports